<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <!--<img id="image" src="" alt="" />-->
      <h1 class="title">QR Service</h1>
      <app-cells><app-button @click.native="onShowCreateModal">Create QR</app-button></app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #name="{ row }">
          <div class="table-default__left table-default__controls">
            <a
              :href="row.link"
              target="_blank"
              class="table-default__snacks-link"
            ></a>
            {{ row.name }}
          </div>
        </template>
        <template #image="{ row }">
          <div class="table-default__controls">
            <button v-if="row.image" @click="onDownloadQR(row)" type="button">
              <img src="@/assets/img/download-table-blue-icon.svg" alt="">
            </button>
            <button v-else type="button" disabled><img src="@/assets/img/not-check-red-icon.svg" alt=""></button>
          </div>
        </template>
        <template #uses="{ row }">
          {{ row.uses.toLocaleString() }}
        </template>
      </v-client-table>
    </template>
    <modal
      name="create"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('create')" class="popup__close" type="button"></button>
        <div class="popup__title">Create QR</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Name" label-for="name" required>
              <app-input
                v-model="form.name"
                id="name"
                name="name"
                placeholder="Name"
                :error="$v.form.name.$error"
              />
              <template #error>
                <div v-if="$v.form.name.$dirty && !$v.form.name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Link" label-for="link" required>
              <app-input
                v-model="form.link"
                id="link"
                name="link"
                placeholder="Link"
                :error="$v.form.link.$error"
              />
              <template #error>
                <div v-if="$v.form.link.$model && $v.form.link.$invalid">Wrong link</div>
                <div v-if="$v.form.link.$dirty && !$v.form.link.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="create" :disabled="$v.form.$error">Create</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getQRServices, postQRService } from '@/http'
import { required, url } from 'vuelidate/lib/validators'
import axios from 'axios'
export default {
  name: 'QRService',
  data() {
    return {
      table: {
        items: [],
        columns: ['name', 'image', 'uses'],
        options: {
          headings: {
            'name': 'Name',
            'image': 'QR',
            'uses': 'Uses',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {},
      is_loaded: false,
      table_preloader: false,
      pasteCatcher: null,
    }
  },
  validations: {
    form: {
      name: { required },
      link: { required, url },
    }
  },
  created() {
    this.fetchItems()

    // document.onpaste = function (pasteEvent) {
    //   const item = pasteEvent.clipboardData.items[0]
    //
    //   if (item.type.indexOf('image') === 0) {
    //     const blob = item.getAsFile()
    //     const reader = new FileReader()
    //
    //     reader.onload = function (event) {
    //       document.getElementById('image').src = event.target.result
    //     }
    //     reader.readAsDataURL(blob)
    //   }
    // }
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getQRServices({ page: this.pagination.page, page_size: 20 })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.create.preload = true
      postQRService(this.form)
        .finally(() => { this.$refs.create.preload = false })
        .then(() => {
          this.fetchItems()
          this.$modal.hide('create')
        })
    },
    onShowCreateModal() {
      this.form = {}
      this.$v.form.$reset()
      this.$modal.show('create')
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    onDownloadQR(row) {
      axios.get(row.image.file, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', `QR - ${row.name}.${row.image.file_name.split('.').pop()}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    }
  }
}
</script>
